import React from 'react'
import Svg from './Svg'
export const SvgFile = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M20.8 5.6l-5.2-5c-.4-.4-.9-.6-1.4-.6H4.6c-1.1 0-2 .9-2 2v20c0 1.1.9 2 2 2h14.8c1.1 0 2-.9 2-2V7c0-.5-.2-1.1-.6-1.4zm-2.5.4h-3.2V3l3.2 3zM4.6 22V2h8.6v5c0 .6.4 1 1 1h5.2v14H4.6z" />
  </Svg>
))
SvgFile.isIcon = true
export default SvgFile
